const index = () => import('./Index');

//2023年全省工业和信息化高质量发展项目
export default {
  routes: [
    {
      path: '/inves/inves/v2023/index',
      name: 'inves_inves_v2023_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/inves/inves/v2023/router.js